import * as Collapsible from "@radix-ui/react-collapsible";

interface CollapseProps {
  children: React.ReactNode;
  trigger: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  className?: string;
}

export const Collapse = ({ children, trigger, open, onOpenChange, className }: CollapseProps) => {
  return (
    <Collapsible.Root open={open} onOpenChange={onOpenChange} className={className}>
      <Collapsible.Trigger asChild>
        {trigger}
      </Collapsible.Trigger>
      <Collapsible.Content
        className={`CollapsibleContent`}
      >
        {children}
      </Collapsible.Content>
    </Collapsible.Root>
  );
};
